import { createClient } from '@supabase/supabase-js';

// Carrega as variáveis de ambiente
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Valida se as variáveis de ambiente foram carregadas corretamente
if (process.env.NODE_ENV !== 'test') {
    if (!supabaseUrl) {
        throw new Error("A variável de ambiente REACT_APP_SUPABASE_URL não está definida.");
    }

    if (!supabaseKey) {
        throw new Error("A variável de ambiente REACT_APP_SUPABASE_ANON_KEY não está definida.");
    }
}

// Cria e exporta o cliente Supabase
// Em ambiente de teste, usamos valores fictícios para evitar erros de inicialização
const url = supabaseUrl || 'https://mock.supabase.co';
const key = supabaseKey || 'mock-key';

export const supabase = createClient(url, key);

